import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-results-review',
  templateUrl: './results-review.component.html',
  styleUrls: ['./results-review.component.css']
})
export class ResultsReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/patients/results-review.component.ts